<template>
    <div>
        <card-header title="Settings" icon="fa-cogs"/>

        <card-body>
            <card-list>
                <navigation-list-item
                    title="Event Descriptions"
                    subtitle="Saved descriptions offered on itinerary and custom events."
                    icon="fa-align-left"
                    class="t-card-list-item"
                    :active="child && child.definition.component === 'event-descriptions'"
                    @click="$openCard('event-descriptions', {}, card)"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardList from "@/TIER/components/CardList";
    import CardBody from "@/TIER/components/CardBody";
    import NavigationListItem from "@/TIER/components/NavigationListItem";

    export default {
        name: "Settings",
        props: ['card', 'child', 'props'],
        components: {NavigationListItem, CardBody, CardList, CardHeader}
    };
</script>

<style lang="scss" scoped>

</style>
